import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {BaseComponent, UsersQuery} from "common-shared";
import {Observable} from "rxjs";
import {ActivityStreamItem} from "../activity-stream-item";
import {EntityTypes} from "web-shared";
import {ConfigService} from "../../../core/services/config.service";

@Component({
  selector: 'app-activity-stream',
  templateUrl: './activity-stream.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActivityStreamComponent extends BaseComponent implements OnInit {
  lastActivities$: Observable<ActivityStreamItem[]>;
  @Input() selectableTypes: { id: number, name: string }[] = [
    {name: EntityTypes[EntityTypes.ItemGroup], id: EntityTypes.ItemGroup},
    {name: EntityTypes[EntityTypes.Item], id: EntityTypes.Item},
    {name: EntityTypes[EntityTypes.Resource], id: EntityTypes.Resource}
  ];
  @Input() selectedTypes: number[] = [EntityTypes.Item, EntityTypes.ItemGroup, EntityTypes.Resource];
  showOnlyByMe:boolean = false;

  constructor(private configService: ConfigService, public usersQuery: UsersQuery) {
    super();
  }

  ngOnInit(): void {
    this.getLastActivities();
  }

  getLastActivities() {
    this.lastActivities$ = this.configService.getLastActivities(this.selectedTypes, this.showOnlyByMe);
  }

  toggleType(typeId: number) {
    if (this.selectedTypes.includes(typeId)) {
      this.selectedTypes = this.selectedTypes.filter(type => type !== typeId);
    } else {
      this.selectedTypes.push(typeId);
    }
    this.getLastActivities();
  }

  toggleOnlyByMe() {
    this.showOnlyByMe = !this.showOnlyByMe;
    this.getLastActivities();
  }
}
